var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quantity", attrs: { id: "Quantity" } }, [
    _c(
      "button",
      {
        staticClass: "quantity__change quantity__change-minus",
        attrs: {
          label: "Decrement Count",
          disabled: _vm.value === 1,
          "aria-label": "Decrease count"
        },
        on: { click: _vm.decrement }
      },
      [
        _c("icon", {
          staticClass: "fill-grey",
          attrs: { name: "minus", size: "14px" }
        })
      ],
      1
    ),
    _c("input", {
      staticClass: "quantity__label text-center",
      attrs: {
        type: "number",
        name: "quantity",
        "aria-labelledby": "Quantity",
        autocomplete: _vm.autocomplete
      },
      domProps: { value: _vm.value },
      on: { change: _vm.change, input: _vm.input }
    }),
    _c(
      "button",
      {
        staticClass: "quantity__change quantity__change-plus",
        attrs: { label: "Increment Count", "aria-label": "Increase count" },
        on: { click: _vm.increment }
      },
      [
        _c("icon", {
          staticClass: "fill-black",
          attrs: { name: "plus", size: "14px" }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }